export default __webpack_public_path__ + "static/cdp-desktop-7f315ec9d45dc7f86fc6ea8958451669.webp";